import React, { useState, useEffect } from "react";
import { Box, Button, InputLabel } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import Grid from "@mui/material/Grid";
import CurrentLocation from "../CurrentLocation";
import { useSelector } from "react-redux";
import { loadUserSelection } from "../../constants/default_request";

export default function LatLongFormat(props) {
  const [userSelection, setUserSelection] = useState({});
  const clientId = useSelector((state) => state.auth.client_id);

  useEffect(() => {
    const loadedSelection = loadUserSelection(clientId);

    if (Object.keys(loadedSelection).length > 0) {
      setUserSelection(loadedSelection);
    }
  }, [clientId]);

  return (
    <Box mt={0} width="100%" align="center">
      <h2 className="sectionTitle center">Latitude / Longitude Format</h2>
      <Grid container justifyContent="center" alignItems="center" spacing={3}>
        <Grid item xs={12} md="auto">
          <CurrentLocation
            currentLocationHandler={props.currentLocationHandler}
          />
        </Grid>
        <Grid item xs={12} md="auto">
          <Box>
            {Object.keys(userSelection).length > 0 && (
              <Button
                variant="contained"
                color="primary"
                size="large"
                data-lat-lon-format={userSelection.latLonFormat}
                key={userSelection.latLonFormat}
                id={userSelection.latLonFormat}
                onClick={(e) => props.handleChange(e)}
              >
                {userSelection.latLonFormat}
              </Button>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} md="auto">
          <FormControl>
            <InputLabel id="lat_long_format-dropdown-label">
              Latitude / Longitude Format
            </InputLabel>
            <Select
              variant="standard"
              labelId="lat_long-dropdown-label"
              id="lat_long-dropdown-filled"
              name="lat_long_format"
              data-testid="lat_long_format-select"
              value={props.lat_long_format}
              onChange={props.handleChange}
              style={{ width: "250px" }}
              displayEmpty
            >
              {props.latLongFormats.map(function (d, idx) {
                return (
                  <MenuItem key={idx} id={d} name={d} value={d}>
                    {d}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <HelpText helpText={getHelpText(props.helpText, "lat_lon")} />
        </Grid>
      </Grid>
    </Box>
  );
}
